import React from 'react';
import ResetPasswordForm from '../components/sections/ResetPasswordForm';

class ResetPassword extends React.Component {
  render() {
    return (
      <ResetPasswordForm className="illustration-section-01" />
    );
  }
}

export default ResetPassword;
